module.exports = __webpack_public_path__ + "img/banner5.47a63514.png";